import React from 'react';
import PropTypes from 'prop-types';
import Endereco from 'components/Endereco';
import { ENUM_TIPO_PESSOA } from 'utils/consts';
import FormPessoa from '../FormPessoa';

export default function FormDadosCadastrais({
  control,
  onChange,
  errors,
  setValue,
  getValues,
  watch,
  setError,
  disabled,
  verificarRepeticao,
}) {
  return (
    <>
      <FormPessoa
        control={control}
        onChange={onChange}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        setError={setError}
        disabled={disabled}
        verificarRepeticao={verificarRepeticao}
        disableDocumento={true}
      />
      <Endereco
        titulo={'Endereço'}
        control={control}
        onChange={onChange}
        errors={errors}
        getValues={getValues}
        setValue={setValue}
        setError={setError}
        disabled={disabled}
        atributo={watch('tipoPessoa') === ENUM_TIPO_PESSOA.juridica.descricao ? 'enderecoPj' : 'enderecoPf'}
      />
    </>
  );
}

FormDadosCadastrais.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  getValues: PropTypes.func,
  setError: PropTypes.func,
  salvarAquivos: PropTypes.func,
  disabled: PropTypes.bool,
};
